import { Button, Typography } from "@mui/material";
import classNames from "classnames";
import clsx from "clsx";
import { ErrorMessage, Field, Form, Formik } from "formik";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { t } from "ttag";
import * as Yup from "yup";
import { useStoreActions, useStoreState } from "../../models/RootStore";
import assetsService from "../../services/assetsService";
import Confirmation2FADialog from "../../components/Confirmation2FADialog";
import useStyles from "./Login.style";

export default function Login(props: any) {
  const style: any = useStyles();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [is2FADialogOpen, setIs2FADialogOpen] = useState(false);

  const login = useStoreActions((actions) => actions.users.login);
  const user = useStoreState((state) => state.users.me);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const { mySupportedPages = "all" } = useStoreState((s) => s.users);
  const showAllPages = mySupportedPages === "all";
  const { isLoggedIn } = user;
  const { history } = props;
  const [loader, setLoder] = React.useState(false);
  useEffect(() => {
    if (isLoggedIn) {
      if (!showAllPages && _.isEmpty(mySupportedPages)) {
        alert("You are not allowed to proceed");
      }
      else {
        history.push(`/dashboard`);
      }
    }
  }, [isLoggedIn, history]);

  const validationSchema = Yup.object({
    username: Yup.string().required(t`required field`),
    password: Yup.string().required(t`required field`)
  });

  const handleSubmit = (values: any) => {
    const { username, password } = values;
    if (loader) {
      return;
    }
    setErrorMsg("");
    setLoder(true);
    login({ username, password })
      .then((data: any) => {
        // Check if 2FA is required
        if (data?.is2FA) {
          setIs2FADialogOpen(true);
        }
      })
      .catch((error: any) => setErrorMsg(t`${error.message}`))
      .finally(() => setLoder(false));

  };

  const close2FADialog = () => {
    setIs2FADialogOpen(false);
  }

  return (
    <>
      <div className={style.loginContainer}>
        <div className={style.logoSection}>
          <img alt="logo" src={assetsService.getResourcePath("fullLogo.png")} />
        </div>

        <Formik
          initialValues={{ username: "", password: "" }}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          validationSchema={validationSchema}
          render={({ values, setFieldValue, ...formikProps }) => {
            return (
              <Form translate="yes" className={style.contentSection}>
                <h1 className={style.welcomeMessage}>
                  {t`Welcome! Please login.`}
                </h1>
                <Field
                  name="username"
                  placeholder={t`Username`}
                  formikprops={formikProps}
                  className={clsx(style.usernameStyle, style.inputClass)}
                />
                <ErrorMessage
                  name="username"
                  component="div"
                  className={style.errorStyle}
                />

                <Field
                  name="password"
                  placeholder={t`Password`}
                  formikprops={formikProps}
                  className={clsx(style.passwordStyle, style.inputClass)}
                  type="password"
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className={style.errorStyle}
                />
                {errorMsg && <Typography className={style.errorMsg}>{errorMsg}</Typography>}
                <Button
                  type="submit"
                  className={clsx(style.LoginButtonsStyle, style.submitButton)}
                >{t`Login`}</Button>
              </Form>
            );
          }}
        />
      </div>
      {is2FADialogOpen &&
        <Confirmation2FADialog onCancel={close2FADialog} />
      }
    </>
  );
}
